/**
 * @prettier
 */
import PropertiesKeyword from "../../components/keywords/Properties"
import { createOnlyOAS32ComponentWrapper } from "../../../fn"

const PropertiesWrapper = createOnlyOAS32ComponentWrapper(PropertiesKeyword)

export default PropertiesWrapper
